import CoreInputTextBottom from "./CoreInputTextBottom";
import createFabric from "../../../../../fabrics/createFabric";

export default createFabric("Bottom", CoreInputTextBottom);
